import { BASE_PATH as I, BaseAPI as b, operationServerMap as p } from "../base.js";
import { DUMMY_BASE_URL as P, assertParamExists as d, createRequestFunction as v, serializeDataIfNeeded as O, setSearchParams as u, toPathString as V } from "../common.js";
import S from "axios";
var R = function(a) {
  return {
    merchantPmsItemBatchAddStockManage: async (m, r, n = {}) => {
      d("merchantPmsItemBatchAddStockManage", "shopId", m);
      const t = new URL("/merchant/pms/item/stock_manage/batch", P);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "POST",
        ...e,
        ...n
      }, l = {}, o = {};
      m !== void 0 && (o.shopId = m), r !== void 0 && (o.stockManage = r), u(t, o);
      let c = e && e.headers ? e.headers : {};
      return s.headers = {
        ...l,
        ...c,
        ...n.headers
      }, {
        url: V(t),
        options: s
      };
    },
    merchantPmsItemCancelDiscount: async (m, r = {}) => {
      d("merchantPmsItemCancelDiscount", "itemDiscountUpdateVO", m);
      const n = new URL("/merchant/pms/item/cancel_discount", P);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...r
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(n, l);
      let o = t && t.headers ? t.headers : {};
      return e.headers = {
        ...s,
        ...o,
        ...r.headers
      }, e.data = O(m, e, a), {
        url: V(n),
        options: e
      };
    },
    merchantPmsItemCheckItemsCanDelete: async (m, r = {}) => {
      d("merchantPmsItemCheckItemsCanDelete", "requestBody", m);
      const n = new URL("/merchant/pms/item/check_delete", P);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...r
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(n, l);
      let o = t && t.headers ? t.headers : {};
      return e.headers = {
        ...s,
        ...o,
        ...r.headers
      }, e.data = O(m, e, a), {
        url: V(n),
        options: e
      };
    },
    merchantPmsItemCheckShopHasItems: async (m, r = {}) => {
      d("merchantPmsItemCheckShopHasItems", "shopId", m);
      const n = "/merchant/pms/item/exists/{shopId}".replace("{shopId}", encodeURIComponent(String(m))), t = new URL(n, P);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "GET",
        ...e,
        ...r
      }, l = {};
      u(t, {});
      let o = e && e.headers ? e.headers : {};
      return s.headers = {
        ...l,
        ...o,
        ...r.headers
      }, {
        url: V(t),
        options: s
      };
    },
    merchantPmsItemCreateItem: async (m, r = {}) => {
      d("merchantPmsItemCreateItem", "merchantPmsItemVO", m);
      const n = new URL("/merchant/pms/item", P);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...r
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(n, l);
      let o = t && t.headers ? t.headers : {};
      return e.headers = {
        ...s,
        ...o,
        ...r.headers
      }, e.data = O(m, e, a), {
        url: V(n),
        options: e
      };
    },
    merchantPmsItemDeleteItem: async (m, r = {}) => {
      d("merchantPmsItemDeleteItem", "itemId", m);
      const n = "/merchant/pms/item/{itemId}".replace("{itemId}", encodeURIComponent(String(m))), t = new URL(n, P);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "DELETE",
        ...e,
        ...r
      }, l = {};
      u(t, {});
      let o = e && e.headers ? e.headers : {};
      return s.headers = {
        ...l,
        ...o,
        ...r.headers
      }, {
        url: V(t),
        options: s
      };
    },
    merchantPmsItemDeleteItems: async (m, r = {}) => {
      d("merchantPmsItemDeleteItems", "requestBody", m);
      const n = new URL("/merchant/pms/item/batch", P);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "DELETE",
        ...t,
        ...r
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(n, l);
      let o = t && t.headers ? t.headers : {};
      return e.headers = {
        ...s,
        ...o,
        ...r.headers
      }, e.data = O(m, e, a), {
        url: V(n),
        options: e
      };
    },
    merchantPmsItemGetItemById: async (m, r = {}) => {
      d("merchantPmsItemGetItemById", "itemId", m);
      const n = "/merchant/pms/item/{itemId}".replace("{itemId}", encodeURIComponent(String(m))), t = new URL(n, P);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "GET",
        ...e,
        ...r
      }, l = {};
      u(t, {});
      let o = e && e.headers ? e.headers : {};
      return s.headers = {
        ...l,
        ...o,
        ...r.headers
      }, {
        url: V(t),
        options: s
      };
    },
    merchantPmsItemGetItemListBySearchValue: async (m, r = {}) => {
      d("merchantPmsItemGetItemListBySearchValue", "query", m);
      const n = new URL("/merchant/pms/item/search_item", P);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "GET",
        ...t,
        ...r
      }, s = {}, l = {};
      if (m !== void 0) for (const [c, h] of Object.entries(m)) l[c] = h;
      u(n, l);
      let o = t && t.headers ? t.headers : {};
      return e.headers = {
        ...s,
        ...o,
        ...r.headers
      }, {
        url: V(n),
        options: e
      };
    },
    merchantPmsItemGetRecommendItemList: async (m, r = {}) => {
      d("merchantPmsItemGetRecommendItemList", "shopId", m);
      const n = "/merchant/pms/item/recommend/{shopId}".replace("{shopId}", encodeURIComponent(String(m))), t = new URL(n, P);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "GET",
        ...e,
        ...r
      }, l = {};
      u(t, {});
      let o = e && e.headers ? e.headers : {};
      return s.headers = {
        ...l,
        ...o,
        ...r.headers
      }, {
        url: V(t),
        options: s
      };
    },
    merchantPmsItemGetRecommendItemList2C: async (m, r = {}) => {
      d("merchantPmsItemGetRecommendItemList2C", "shopId", m);
      const n = "/merchant/pms/item/recommend_2c/{shopId}".replace("{shopId}", encodeURIComponent(String(m))), t = new URL(n, P);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "GET",
        ...e,
        ...r
      }, l = {};
      u(t, {});
      let o = e && e.headers ? e.headers : {};
      return s.headers = {
        ...l,
        ...o,
        ...r.headers
      }, {
        url: V(t),
        options: s
      };
    },
    merchantPmsItemGetTotalItemInfoList: async (m, r = {}) => {
      const n = new URL("/merchant/pms/item/total", P);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "GET",
        ...t,
        ...r
      }, s = {}, l = {};
      m !== void 0 && (l.itemName = m), u(n, l);
      let o = t && t.headers ? t.headers : {};
      return e.headers = {
        ...s,
        ...o,
        ...r.headers
      }, {
        url: V(n),
        options: e
      };
    },
    merchantPmsItemGetTotalItemInfoListV2: async (m, r, n = {}) => {
      const t = new URL("/merchant/pms/item/total_v2", P);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "GET",
        ...e,
        ...n
      }, l = {}, o = {};
      m !== void 0 && (o.itemName = m), r !== void 0 && (o.hasCreditBind = r), u(t, o);
      let c = e && e.headers ? e.headers : {};
      return s.headers = {
        ...l,
        ...c,
        ...n.headers
      }, {
        url: V(t),
        options: s
      };
    },
    merchantPmsItemImportItem: async (m, r = {}) => {
      d("merchantPmsItemImportItem", "pmsItemVO", m);
      const n = new URL("/merchant/pms/item/import", P);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...r
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(n, l);
      let o = t && t.headers ? t.headers : {};
      return e.headers = {
        ...s,
        ...o,
        ...r.headers
      }, e.data = O(m, e, a), {
        url: V(n),
        options: e
      };
    },
    merchantPmsItemMoveItem: async (m, r, n = {}) => {
      d("merchantPmsItemMoveItem", "itemId", m), d("merchantPmsItemMoveItem", "direction", r);
      const t = new URL("/merchant/pms/item/move", P);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "PATCH",
        ...e,
        ...n
      }, l = {}, o = {};
      m !== void 0 && (o.itemId = m), r !== void 0 && (o.direction = r), u(t, o);
      let c = e && e.headers ? e.headers : {};
      return s.headers = {
        ...l,
        ...c,
        ...n.headers
      }, {
        url: V(t),
        options: s
      };
    },
    merchantPmsItemMoveItemV2: async (m, r = {}) => {
      d("merchantPmsItemMoveItemV2", "moveProductVO", m);
      const n = new URL("/merchant/pms/item/move", P);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...r
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(n, l);
      let o = t && t.headers ? t.headers : {};
      return e.headers = {
        ...s,
        ...o,
        ...r.headers
      }, e.data = O(m, e, a), {
        url: V(n),
        options: e
      };
    },
    merchantPmsItemSearchItem: async (m, r, n, t, e = {}) => {
      d("merchantPmsItemSearchItem", "shopId", m), d("merchantPmsItemSearchItem", "searchValue", r), d("merchantPmsItemSearchItem", "pageNum", n), d("merchantPmsItemSearchItem", "pageSize", t);
      const s = new URL("/merchant/pms/item/search", P);
      let l;
      a && (l = a.baseOptions);
      const o = {
        method: "GET",
        ...l,
        ...e
      }, c = {}, h = {};
      m !== void 0 && (h.shopId = m), r !== void 0 && (h.searchValue = r), n !== void 0 && (h.pageNum = n), t !== void 0 && (h.pageSize = t), u(s, h);
      let U = l && l.headers ? l.headers : {};
      return o.headers = {
        ...c,
        ...U,
        ...e.headers
      }, {
        url: V(s),
        options: o
      };
    },
    merchantPmsItemSetDisplayStatus: async (m, r, n = {}) => {
      d("merchantPmsItemSetDisplayStatus", "itemId", m), d("merchantPmsItemSetDisplayStatus", "isShopDisplay", r);
      const t = new URL("/merchant/pms/item/display", P);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "PATCH",
        ...e,
        ...n
      }, l = {}, o = {};
      m !== void 0 && (o.itemId = m), r !== void 0 && (o.isShopDisplay = r), u(t, o);
      let c = e && e.headers ? e.headers : {};
      return s.headers = {
        ...l,
        ...c,
        ...n.headers
      }, {
        url: V(t),
        options: s
      };
    },
    merchantPmsItemSetRecommendStatus: async (m, r, n = {}) => {
      d("merchantPmsItemSetRecommendStatus", "itemId", m), d("merchantPmsItemSetRecommendStatus", "isRecommend", r);
      const t = new URL("/merchant/pms/item/set_recommend", P);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "PATCH",
        ...e,
        ...n
      }, l = {}, o = {};
      m !== void 0 && (o.itemId = m), r !== void 0 && (o.isRecommend = r), u(t, o);
      let c = e && e.headers ? e.headers : {};
      return s.headers = {
        ...l,
        ...c,
        ...n.headers
      }, {
        url: V(t),
        options: s
      };
    },
    merchantPmsItemSetRecommendStatusBatch: async (m, r = {}) => {
      d("merchantPmsItemSetRecommendStatusBatch", "merchantPmsItem", m);
      const n = new URL("/merchant/pms/item/set_recommend_batch", P);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "PATCH",
        ...t,
        ...r
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(n, l);
      let o = t && t.headers ? t.headers : {};
      return e.headers = {
        ...s,
        ...o,
        ...r.headers
      }, e.data = O(m, e, a), {
        url: V(n),
        options: e
      };
    },
    merchantPmsItemToggleItemStatus: async (m, r, n = {}) => {
      d("merchantPmsItemToggleItemStatus", "itemId", m), d("merchantPmsItemToggleItemStatus", "isSales", r);
      const t = new URL("/merchant/pms/item/toggleSales", P);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "PATCH",
        ...e,
        ...n
      }, l = {}, o = {};
      m !== void 0 && (o.itemId = m), r !== void 0 && (o.isSales = r), u(t, o);
      let c = e && e.headers ? e.headers : {};
      return s.headers = {
        ...l,
        ...c,
        ...n.headers
      }, {
        url: V(t),
        options: s
      };
    },
    merchantPmsItemUpdateBrandPointEarning: async (m, r = {}) => {
      d("merchantPmsItemUpdateBrandPointEarning", "brandPointProductConfigRequest", m);
      const n = new URL("/merchant/pms/item/update_brand_point_earning", P);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...r
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(n, l);
      let o = t && t.headers ? t.headers : {};
      return e.headers = {
        ...s,
        ...o,
        ...r.headers
      }, e.data = O(m, e, a), {
        url: V(n),
        options: e
      };
    },
    merchantPmsItemUpdateBrandPointRedemption: async (m, r = {}) => {
      d("merchantPmsItemUpdateBrandPointRedemption", "brandPointRedemptionConfigRequest", m);
      const n = new URL("/merchant/pms/item/update_brand_point_redemption", P);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...r
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(n, l);
      let o = t && t.headers ? t.headers : {};
      return e.headers = {
        ...s,
        ...o,
        ...r.headers
      }, e.data = O(m, e, a), {
        url: V(n),
        options: e
      };
    },
    merchantPmsItemUpdateCashbackable: async (m, r = {}) => {
      d("merchantPmsItemUpdateCashbackable", "itemCashbackableUpdateVO", m);
      const n = new URL("/merchant/pms/item/update_cashbackable", P);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...r
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(n, l);
      let o = t && t.headers ? t.headers : {};
      return e.headers = {
        ...s,
        ...o,
        ...r.headers
      }, e.data = O(m, e, a), {
        url: V(n),
        options: e
      };
    },
    merchantPmsItemUpdateDiscount: async (m, r = {}) => {
      d("merchantPmsItemUpdateDiscount", "itemDiscountUpdateVO", m);
      const n = new URL("/merchant/pms/item/update_discount", P);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...r
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(n, l);
      let o = t && t.headers ? t.headers : {};
      return e.headers = {
        ...s,
        ...o,
        ...r.headers
      }, e.data = O(m, e, a), {
        url: V(n),
        options: e
      };
    },
    merchantPmsItemUpdateFullDiscount: async (m, r = {}) => {
      d("merchantPmsItemUpdateFullDiscount", "itemFullDiscountUpdateVO", m);
      const n = new URL("/merchant/pms/item/update_full_discount", P);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...r
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(n, l);
      let o = t && t.headers ? t.headers : {};
      return e.headers = {
        ...s,
        ...o,
        ...r.headers
      }, e.data = O(m, e, a), {
        url: V(n),
        options: e
      };
    },
    merchantPmsItemUpdateGiftSend: async (m, r = {}) => {
      d("merchantPmsItemUpdateGiftSend", "itemGiftSendBatchUpdateRequest", m);
      const n = new URL("/merchant/pms/item/gift-send", P);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "PATCH",
        ...t,
        ...r
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(n, l);
      let o = t && t.headers ? t.headers : {};
      return e.headers = {
        ...s,
        ...o,
        ...r.headers
      }, e.data = O(m, e, a), {
        url: V(n),
        options: e
      };
    },
    merchantPmsItemUpdateItem: async (m, r = {}) => {
      d("merchantPmsItemUpdateItem", "merchantPmsItemVO", m);
      const n = new URL("/merchant/pms/item", P);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "PUT",
        ...t,
        ...r
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(n, l);
      let o = t && t.headers ? t.headers : {};
      return e.headers = {
        ...s,
        ...o,
        ...r.headers
      }, e.data = O(m, e, a), {
        url: V(n),
        options: e
      };
    },
    merchantPmsItemUpdateLowestConsume: async (m, r = {}) => {
      d("merchantPmsItemUpdateLowestConsume", "itemLowestUpdateVO", m);
      const n = new URL("/merchant/pms/item/update_lowest", P);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...r
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(n, l);
      let o = t && t.headers ? t.headers : {};
      return e.headers = {
        ...s,
        ...o,
        ...r.headers
      }, e.data = O(m, e, a), {
        url: V(n),
        options: e
      };
    },
    merchantPmsItemUpdateSales: async (m, r = {}) => {
      d("merchantPmsItemUpdateSales", "itemSalesUpdateVO", m);
      const n = new URL("/merchant/pms/item/update_sales", P);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...r
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(n, l);
      let o = t && t.headers ? t.headers : {};
      return e.headers = {
        ...s,
        ...o,
        ...r.headers
      }, e.data = O(m, e, a), {
        url: V(n),
        options: e
      };
    },
    merchantPmsItemUpdateStockManage: async (m, r = {}) => {
      d("merchantPmsItemUpdateStockManage", "itemStockMangeUpdateVO", m);
      const n = new URL("/merchant/pms/item/update_stock_manage", P);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...r
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(n, l);
      let o = t && t.headers ? t.headers : {};
      return e.headers = {
        ...s,
        ...o,
        ...r.headers
      }, e.data = O(m, e, a), {
        url: V(n),
        options: e
      };
    },
    merchantPmsItemUpload: async (m, r = {}) => {
      const n = new URL("/merchant/pms/item/upload", P);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...r
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(n, l);
      let o = t && t.headers ? t.headers : {};
      return e.headers = {
        ...s,
        ...o,
        ...r.headers
      }, e.data = O(m, e, a), {
        url: V(n),
        options: e
      };
    },
    merchantPmsItemUploadVideo: async (m, r = {}) => {
      const n = new URL("/merchant/pms/item/video/upload", P);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...r
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(n, l);
      let o = t && t.headers ? t.headers : {};
      return e.headers = {
        ...s,
        ...o,
        ...r.headers
      }, e.data = O(m, e, a), {
        url: V(n),
        options: e
      };
    }
  };
}, i = function(a) {
  const m = R(a);
  return {
    async merchantPmsItemBatchAddStockManage(r, n, t) {
      var e, s;
      const l = await m.merchantPmsItemBatchAddStockManage(r, n, t), o = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, c = (s = p["MerchantPmsItemApi.merchantPmsItemBatchAddStockManage"]) === null || s === void 0 || (s = s[o]) === null || s === void 0 ? void 0 : s.url;
      return (h, U) => v(l, S, I, a)(h, c || U);
    },
    async merchantPmsItemCancelDiscount(r, n) {
      var t, e;
      const s = await m.merchantPmsItemCancelDiscount(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = p["MerchantPmsItemApi.merchantPmsItemCancelDiscount"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(s, S, I, a)(c, o || h);
    },
    async merchantPmsItemCheckItemsCanDelete(r, n) {
      var t, e;
      const s = await m.merchantPmsItemCheckItemsCanDelete(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = p["MerchantPmsItemApi.merchantPmsItemCheckItemsCanDelete"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(s, S, I, a)(c, o || h);
    },
    async merchantPmsItemCheckShopHasItems(r, n) {
      var t, e;
      const s = await m.merchantPmsItemCheckShopHasItems(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = p["MerchantPmsItemApi.merchantPmsItemCheckShopHasItems"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(s, S, I, a)(c, o || h);
    },
    async merchantPmsItemCreateItem(r, n) {
      var t, e;
      const s = await m.merchantPmsItemCreateItem(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = p["MerchantPmsItemApi.merchantPmsItemCreateItem"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(s, S, I, a)(c, o || h);
    },
    async merchantPmsItemDeleteItem(r, n) {
      var t, e;
      const s = await m.merchantPmsItemDeleteItem(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = p["MerchantPmsItemApi.merchantPmsItemDeleteItem"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(s, S, I, a)(c, o || h);
    },
    async merchantPmsItemDeleteItems(r, n) {
      var t, e;
      const s = await m.merchantPmsItemDeleteItems(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = p["MerchantPmsItemApi.merchantPmsItemDeleteItems"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(s, S, I, a)(c, o || h);
    },
    async merchantPmsItemGetItemById(r, n) {
      var t, e;
      const s = await m.merchantPmsItemGetItemById(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = p["MerchantPmsItemApi.merchantPmsItemGetItemById"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(s, S, I, a)(c, o || h);
    },
    async merchantPmsItemGetItemListBySearchValue(r, n) {
      var t, e;
      const s = await m.merchantPmsItemGetItemListBySearchValue(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = p["MerchantPmsItemApi.merchantPmsItemGetItemListBySearchValue"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(s, S, I, a)(c, o || h);
    },
    async merchantPmsItemGetRecommendItemList(r, n) {
      var t, e;
      const s = await m.merchantPmsItemGetRecommendItemList(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = p["MerchantPmsItemApi.merchantPmsItemGetRecommendItemList"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(s, S, I, a)(c, o || h);
    },
    async merchantPmsItemGetRecommendItemList2C(r, n) {
      var t, e;
      const s = await m.merchantPmsItemGetRecommendItemList2C(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = p["MerchantPmsItemApi.merchantPmsItemGetRecommendItemList2C"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(s, S, I, a)(c, o || h);
    },
    async merchantPmsItemGetTotalItemInfoList(r, n) {
      var t, e;
      const s = await m.merchantPmsItemGetTotalItemInfoList(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = p["MerchantPmsItemApi.merchantPmsItemGetTotalItemInfoList"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(s, S, I, a)(c, o || h);
    },
    async merchantPmsItemGetTotalItemInfoListV2(r, n, t) {
      var e, s;
      const l = await m.merchantPmsItemGetTotalItemInfoListV2(r, n, t), o = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, c = (s = p["MerchantPmsItemApi.merchantPmsItemGetTotalItemInfoListV2"]) === null || s === void 0 || (s = s[o]) === null || s === void 0 ? void 0 : s.url;
      return (h, U) => v(l, S, I, a)(h, c || U);
    },
    async merchantPmsItemImportItem(r, n) {
      var t, e;
      const s = await m.merchantPmsItemImportItem(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = p["MerchantPmsItemApi.merchantPmsItemImportItem"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(s, S, I, a)(c, o || h);
    },
    async merchantPmsItemMoveItem(r, n, t) {
      var e, s;
      const l = await m.merchantPmsItemMoveItem(r, n, t), o = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, c = (s = p["MerchantPmsItemApi.merchantPmsItemMoveItem"]) === null || s === void 0 || (s = s[o]) === null || s === void 0 ? void 0 : s.url;
      return (h, U) => v(l, S, I, a)(h, c || U);
    },
    async merchantPmsItemMoveItemV2(r, n) {
      var t, e;
      const s = await m.merchantPmsItemMoveItemV2(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = p["MerchantPmsItemApi.merchantPmsItemMoveItemV2"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(s, S, I, a)(c, o || h);
    },
    async merchantPmsItemSearchItem(r, n, t, e, s) {
      var l, o;
      const c = await m.merchantPmsItemSearchItem(r, n, t, e, s), h = (l = a == null ? void 0 : a.serverIndex) !== null && l !== void 0 ? l : 0, U = (o = p["MerchantPmsItemApi.merchantPmsItemSearchItem"]) === null || o === void 0 || (o = o[h]) === null || o === void 0 ? void 0 : o.url;
      return (y, M) => v(c, S, I, a)(y, U || M);
    },
    async merchantPmsItemSetDisplayStatus(r, n, t) {
      var e, s;
      const l = await m.merchantPmsItemSetDisplayStatus(r, n, t), o = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, c = (s = p["MerchantPmsItemApi.merchantPmsItemSetDisplayStatus"]) === null || s === void 0 || (s = s[o]) === null || s === void 0 ? void 0 : s.url;
      return (h, U) => v(l, S, I, a)(h, c || U);
    },
    async merchantPmsItemSetRecommendStatus(r, n, t) {
      var e, s;
      const l = await m.merchantPmsItemSetRecommendStatus(r, n, t), o = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, c = (s = p["MerchantPmsItemApi.merchantPmsItemSetRecommendStatus"]) === null || s === void 0 || (s = s[o]) === null || s === void 0 ? void 0 : s.url;
      return (h, U) => v(l, S, I, a)(h, c || U);
    },
    async merchantPmsItemSetRecommendStatusBatch(r, n) {
      var t, e;
      const s = await m.merchantPmsItemSetRecommendStatusBatch(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = p["MerchantPmsItemApi.merchantPmsItemSetRecommendStatusBatch"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(s, S, I, a)(c, o || h);
    },
    async merchantPmsItemToggleItemStatus(r, n, t) {
      var e, s;
      const l = await m.merchantPmsItemToggleItemStatus(r, n, t), o = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, c = (s = p["MerchantPmsItemApi.merchantPmsItemToggleItemStatus"]) === null || s === void 0 || (s = s[o]) === null || s === void 0 ? void 0 : s.url;
      return (h, U) => v(l, S, I, a)(h, c || U);
    },
    async merchantPmsItemUpdateBrandPointEarning(r, n) {
      var t, e;
      const s = await m.merchantPmsItemUpdateBrandPointEarning(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = p["MerchantPmsItemApi.merchantPmsItemUpdateBrandPointEarning"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(s, S, I, a)(c, o || h);
    },
    async merchantPmsItemUpdateBrandPointRedemption(r, n) {
      var t, e;
      const s = await m.merchantPmsItemUpdateBrandPointRedemption(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = p["MerchantPmsItemApi.merchantPmsItemUpdateBrandPointRedemption"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(s, S, I, a)(c, o || h);
    },
    async merchantPmsItemUpdateCashbackable(r, n) {
      var t, e;
      const s = await m.merchantPmsItemUpdateCashbackable(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = p["MerchantPmsItemApi.merchantPmsItemUpdateCashbackable"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(s, S, I, a)(c, o || h);
    },
    async merchantPmsItemUpdateDiscount(r, n) {
      var t, e;
      const s = await m.merchantPmsItemUpdateDiscount(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = p["MerchantPmsItemApi.merchantPmsItemUpdateDiscount"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(s, S, I, a)(c, o || h);
    },
    async merchantPmsItemUpdateFullDiscount(r, n) {
      var t, e;
      const s = await m.merchantPmsItemUpdateFullDiscount(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = p["MerchantPmsItemApi.merchantPmsItemUpdateFullDiscount"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(s, S, I, a)(c, o || h);
    },
    async merchantPmsItemUpdateGiftSend(r, n) {
      var t, e;
      const s = await m.merchantPmsItemUpdateGiftSend(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = p["MerchantPmsItemApi.merchantPmsItemUpdateGiftSend"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(s, S, I, a)(c, o || h);
    },
    async merchantPmsItemUpdateItem(r, n) {
      var t, e;
      const s = await m.merchantPmsItemUpdateItem(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = p["MerchantPmsItemApi.merchantPmsItemUpdateItem"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(s, S, I, a)(c, o || h);
    },
    async merchantPmsItemUpdateLowestConsume(r, n) {
      var t, e;
      const s = await m.merchantPmsItemUpdateLowestConsume(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = p["MerchantPmsItemApi.merchantPmsItemUpdateLowestConsume"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(s, S, I, a)(c, o || h);
    },
    async merchantPmsItemUpdateSales(r, n) {
      var t, e;
      const s = await m.merchantPmsItemUpdateSales(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = p["MerchantPmsItemApi.merchantPmsItemUpdateSales"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(s, S, I, a)(c, o || h);
    },
    async merchantPmsItemUpdateStockManage(r, n) {
      var t, e;
      const s = await m.merchantPmsItemUpdateStockManage(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = p["MerchantPmsItemApi.merchantPmsItemUpdateStockManage"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(s, S, I, a)(c, o || h);
    },
    async merchantPmsItemUpload(r, n) {
      var t, e;
      const s = await m.merchantPmsItemUpload(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = p["MerchantPmsItemApi.merchantPmsItemUpload"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(s, S, I, a)(c, o || h);
    },
    async merchantPmsItemUploadVideo(r, n) {
      var t, e;
      const s = await m.merchantPmsItemUploadVideo(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, o = (e = p["MerchantPmsItemApi.merchantPmsItemUploadVideo"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => v(s, S, I, a)(c, o || h);
    }
  };
}, x = function(a, m, r) {
  const n = i(a);
  return {
    merchantPmsItemBatchAddStockManage(t, e) {
      return n.merchantPmsItemBatchAddStockManage(t.shopId, t.stockManage, e).then((s) => s(r, m));
    },
    merchantPmsItemCancelDiscount(t, e) {
      return n.merchantPmsItemCancelDiscount(t.itemDiscountUpdateVO, e).then((s) => s(r, m));
    },
    merchantPmsItemCheckItemsCanDelete(t, e) {
      return n.merchantPmsItemCheckItemsCanDelete(t.requestBody, e).then((s) => s(r, m));
    },
    merchantPmsItemCheckShopHasItems(t, e) {
      return n.merchantPmsItemCheckShopHasItems(t.shopId, e).then((s) => s(r, m));
    },
    merchantPmsItemCreateItem(t, e) {
      return n.merchantPmsItemCreateItem(t.merchantPmsItemVO, e).then((s) => s(r, m));
    },
    merchantPmsItemDeleteItem(t, e) {
      return n.merchantPmsItemDeleteItem(t.itemId, e).then((s) => s(r, m));
    },
    merchantPmsItemDeleteItems(t, e) {
      return n.merchantPmsItemDeleteItems(t.requestBody, e).then((s) => s(r, m));
    },
    merchantPmsItemGetItemById(t, e) {
      return n.merchantPmsItemGetItemById(t.itemId, e).then((s) => s(r, m));
    },
    merchantPmsItemGetItemListBySearchValue(t, e) {
      return n.merchantPmsItemGetItemListBySearchValue(t.query, e).then((s) => s(r, m));
    },
    merchantPmsItemGetRecommendItemList(t, e) {
      return n.merchantPmsItemGetRecommendItemList(t.shopId, e).then((s) => s(r, m));
    },
    merchantPmsItemGetRecommendItemList2C(t, e) {
      return n.merchantPmsItemGetRecommendItemList2C(t.shopId, e).then((s) => s(r, m));
    },
    merchantPmsItemGetTotalItemInfoList(t = {}, e) {
      return n.merchantPmsItemGetTotalItemInfoList(t.itemName, e).then((s) => s(r, m));
    },
    merchantPmsItemGetTotalItemInfoListV2(t = {}, e) {
      return n.merchantPmsItemGetTotalItemInfoListV2(t.itemName, t.hasCreditBind, e).then((s) => s(r, m));
    },
    merchantPmsItemImportItem(t, e) {
      return n.merchantPmsItemImportItem(t.pmsItemVO, e).then((s) => s(r, m));
    },
    merchantPmsItemMoveItem(t, e) {
      return n.merchantPmsItemMoveItem(t.itemId, t.direction, e).then((s) => s(r, m));
    },
    merchantPmsItemMoveItemV2(t, e) {
      return n.merchantPmsItemMoveItemV2(t.moveProductVO, e).then((s) => s(r, m));
    },
    merchantPmsItemSearchItem(t, e) {
      return n.merchantPmsItemSearchItem(t.shopId, t.searchValue, t.pageNum, t.pageSize, e).then((s) => s(r, m));
    },
    merchantPmsItemSetDisplayStatus(t, e) {
      return n.merchantPmsItemSetDisplayStatus(t.itemId, t.isShopDisplay, e).then((s) => s(r, m));
    },
    merchantPmsItemSetRecommendStatus(t, e) {
      return n.merchantPmsItemSetRecommendStatus(t.itemId, t.isRecommend, e).then((s) => s(r, m));
    },
    merchantPmsItemSetRecommendStatusBatch(t, e) {
      return n.merchantPmsItemSetRecommendStatusBatch(t.merchantPmsItem, e).then((s) => s(r, m));
    },
    merchantPmsItemToggleItemStatus(t, e) {
      return n.merchantPmsItemToggleItemStatus(t.itemId, t.isSales, e).then((s) => s(r, m));
    },
    merchantPmsItemUpdateBrandPointEarning(t, e) {
      return n.merchantPmsItemUpdateBrandPointEarning(t.brandPointProductConfigRequest, e).then((s) => s(r, m));
    },
    merchantPmsItemUpdateBrandPointRedemption(t, e) {
      return n.merchantPmsItemUpdateBrandPointRedemption(t.brandPointRedemptionConfigRequest, e).then((s) => s(r, m));
    },
    merchantPmsItemUpdateCashbackable(t, e) {
      return n.merchantPmsItemUpdateCashbackable(t.itemCashbackableUpdateVO, e).then((s) => s(r, m));
    },
    merchantPmsItemUpdateDiscount(t, e) {
      return n.merchantPmsItemUpdateDiscount(t.itemDiscountUpdateVO, e).then((s) => s(r, m));
    },
    merchantPmsItemUpdateFullDiscount(t, e) {
      return n.merchantPmsItemUpdateFullDiscount(t.itemFullDiscountUpdateVO, e).then((s) => s(r, m));
    },
    merchantPmsItemUpdateGiftSend(t, e) {
      return n.merchantPmsItemUpdateGiftSend(t.itemGiftSendBatchUpdateRequest, e).then((s) => s(r, m));
    },
    merchantPmsItemUpdateItem(t, e) {
      return n.merchantPmsItemUpdateItem(t.merchantPmsItemVO, e).then((s) => s(r, m));
    },
    merchantPmsItemUpdateLowestConsume(t, e) {
      return n.merchantPmsItemUpdateLowestConsume(t.itemLowestUpdateVO, e).then((s) => s(r, m));
    },
    merchantPmsItemUpdateSales(t, e) {
      return n.merchantPmsItemUpdateSales(t.itemSalesUpdateVO, e).then((s) => s(r, m));
    },
    merchantPmsItemUpdateStockManage(t, e) {
      return n.merchantPmsItemUpdateStockManage(t.itemStockMangeUpdateVO, e).then((s) => s(r, m));
    },
    merchantPmsItemUpload(t = {}, e) {
      return n.merchantPmsItemUpload(t.merchantPmsItemUploadVideoRequest, e).then((s) => s(r, m));
    },
    merchantPmsItemUploadVideo(t = {}, e) {
      return n.merchantPmsItemUploadVideo(t.merchantPmsItemUploadVideoRequest, e).then((s) => s(r, m));
    }
  };
}, _ = class extends b {
  merchantPmsItemBatchAddStockManage(a, m) {
    return i(this.configuration).merchantPmsItemBatchAddStockManage(a.shopId, a.stockManage, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemCancelDiscount(a, m) {
    return i(this.configuration).merchantPmsItemCancelDiscount(a.itemDiscountUpdateVO, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemCheckItemsCanDelete(a, m) {
    return i(this.configuration).merchantPmsItemCheckItemsCanDelete(a.requestBody, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemCheckShopHasItems(a, m) {
    return i(this.configuration).merchantPmsItemCheckShopHasItems(a.shopId, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemCreateItem(a, m) {
    return i(this.configuration).merchantPmsItemCreateItem(a.merchantPmsItemVO, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemDeleteItem(a, m) {
    return i(this.configuration).merchantPmsItemDeleteItem(a.itemId, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemDeleteItems(a, m) {
    return i(this.configuration).merchantPmsItemDeleteItems(a.requestBody, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemGetItemById(a, m) {
    return i(this.configuration).merchantPmsItemGetItemById(a.itemId, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemGetItemListBySearchValue(a, m) {
    return i(this.configuration).merchantPmsItemGetItemListBySearchValue(a.query, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemGetRecommendItemList(a, m) {
    return i(this.configuration).merchantPmsItemGetRecommendItemList(a.shopId, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemGetRecommendItemList2C(a, m) {
    return i(this.configuration).merchantPmsItemGetRecommendItemList2C(a.shopId, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemGetTotalItemInfoList(a = {}, m) {
    return i(this.configuration).merchantPmsItemGetTotalItemInfoList(a.itemName, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemGetTotalItemInfoListV2(a = {}, m) {
    return i(this.configuration).merchantPmsItemGetTotalItemInfoListV2(a.itemName, a.hasCreditBind, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemImportItem(a, m) {
    return i(this.configuration).merchantPmsItemImportItem(a.pmsItemVO, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemMoveItem(a, m) {
    return i(this.configuration).merchantPmsItemMoveItem(a.itemId, a.direction, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemMoveItemV2(a, m) {
    return i(this.configuration).merchantPmsItemMoveItemV2(a.moveProductVO, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemSearchItem(a, m) {
    return i(this.configuration).merchantPmsItemSearchItem(a.shopId, a.searchValue, a.pageNum, a.pageSize, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemSetDisplayStatus(a, m) {
    return i(this.configuration).merchantPmsItemSetDisplayStatus(a.itemId, a.isShopDisplay, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemSetRecommendStatus(a, m) {
    return i(this.configuration).merchantPmsItemSetRecommendStatus(a.itemId, a.isRecommend, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemSetRecommendStatusBatch(a, m) {
    return i(this.configuration).merchantPmsItemSetRecommendStatusBatch(a.merchantPmsItem, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemToggleItemStatus(a, m) {
    return i(this.configuration).merchantPmsItemToggleItemStatus(a.itemId, a.isSales, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemUpdateBrandPointEarning(a, m) {
    return i(this.configuration).merchantPmsItemUpdateBrandPointEarning(a.brandPointProductConfigRequest, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemUpdateBrandPointRedemption(a, m) {
    return i(this.configuration).merchantPmsItemUpdateBrandPointRedemption(a.brandPointRedemptionConfigRequest, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemUpdateCashbackable(a, m) {
    return i(this.configuration).merchantPmsItemUpdateCashbackable(a.itemCashbackableUpdateVO, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemUpdateDiscount(a, m) {
    return i(this.configuration).merchantPmsItemUpdateDiscount(a.itemDiscountUpdateVO, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemUpdateFullDiscount(a, m) {
    return i(this.configuration).merchantPmsItemUpdateFullDiscount(a.itemFullDiscountUpdateVO, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemUpdateGiftSend(a, m) {
    return i(this.configuration).merchantPmsItemUpdateGiftSend(a.itemGiftSendBatchUpdateRequest, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemUpdateItem(a, m) {
    return i(this.configuration).merchantPmsItemUpdateItem(a.merchantPmsItemVO, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemUpdateLowestConsume(a, m) {
    return i(this.configuration).merchantPmsItemUpdateLowestConsume(a.itemLowestUpdateVO, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemUpdateSales(a, m) {
    return i(this.configuration).merchantPmsItemUpdateSales(a.itemSalesUpdateVO, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemUpdateStockManage(a, m) {
    return i(this.configuration).merchantPmsItemUpdateStockManage(a.itemStockMangeUpdateVO, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemUpload(a = {}, m) {
    return i(this.configuration).merchantPmsItemUpload(a.merchantPmsItemUploadVideoRequest, m).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemUploadVideo(a = {}, m) {
    return i(this.configuration).merchantPmsItemUploadVideo(a.merchantPmsItemUploadVideoRequest, m).then((r) => r(this.axios, this.basePath));
  }
};
export {
  _ as MerchantPmsItemApi,
  R as MerchantPmsItemApiAxiosParamCreator,
  x as MerchantPmsItemApiFactory,
  i as MerchantPmsItemApiFp
};

//# sourceMappingURL=merchant-pms-item-api.js.map